let isNative = false;
try {
  const { Capacitor } = require('@capacitor/core');
  isNative = Capacitor.isNativePlatform();
} catch {
  // Capacitor not installed — running as web app
}

const webOrigin = typeof window !== 'undefined' ? window.location.origin : '';

const redirectSignIn = isNative
  ? ['uk.co.wolftechnologies.cooksmith://callback']
  : [`${webOrigin}/auth/callback`];

const redirectSignOut = isNative
  ? ['uk.co.wolftechnologies.cooksmith://callback']
  : [`${webOrigin}/auth/login`];

const cognitoDomain = process.env.REACT_APP_COGNITO_DOMAIN || '';

const awsConfig = {
  Auth: {
    Cognito: {
      userPoolId: process.env.REACT_APP_USER_POOL_ID || '',
      userPoolClientId: process.env.REACT_APP_USER_POOL_CLIENT_ID || '',
      identityPoolId: process.env.REACT_APP_IDENTITY_POOL_ID || '',
      loginWith: {
        email: true,
        ...(cognitoDomain && {
          oauth: {
            domain: cognitoDomain,
            scopes: ['openid', 'email', 'profile'],
            redirectSignIn,
            redirectSignOut,
            responseType: 'code',
          },
        }),
      },
      signUpVerificationMethod: 'code',
      passwordFormat: {
        minLength: 8,
        requireLowercase: true,
        requireUppercase: true,
        requireNumbers: true,
      },
    },
  },
  API: {
    REST: {
      CooksmithApi: {
        endpoint: process.env.REACT_APP_API_ENDPOINT || '',
        region: process.env.REACT_APP_AWS_REGION || 'eu-west-2',
      },
    },
  },
};

export default awsConfig;
